import { cn } from "@quake/shared-ui/lib/utils";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./tooltip";
import {
  format,
  formatDistanceToNowStrict,
  isThisYear,
  isYesterday,
  differenceInMinutes,
  differenceInDays,
  formatDistanceToNow,
} from "date-fns";

export function humanDate(input: Date | string, now = new Date()) {
  const d = input;

  // "just now"
  const mins = Math.abs(differenceInMinutes(now, d));
  if (mins < 1) return "just now";

  // "45m ago" / "3h ago" (strict gives compact units)
  if (mins < 60 * 24) {
    return formatDistanceToNowStrict(d, {
      addSuffix: true,
      roundingMethod: "floor",
    })
      .replace(" minutes", "m")
      .replace(" minute", "m")
      .replace(" hours", "h")
      .replace(" hour", "h")
      .replace(" seconds", "s")
      .replace(" second", "s");
  }

  // "yesterday" (exact word)
  if (isYesterday(d)) return "yesterday";

  const days = differenceInDays(d, now);
  // is within 30 days period
  if (days > -31 && days < 31) {
    return formatDistanceToNow(d, { addSuffix: true }).replace("in", "In").replace("over", "Over"); // In XX days or XX days ago
  }

  // "3rd Feb" or "12 Dec 2024"
  if (isThisYear(d)) return format(d, "do MMM"); // 3rd Feb
  return format(d, "d MMM yyyy"); // 12 Dec 2024
}

export function HumanDateWithTooltip({ date, className }: { date: Date | string; className?: string }) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger className={cn("cursor-help", className)}>{humanDate(date)}</TooltipTrigger>
        <TooltipContent>{new Date(date).toLocaleString()}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
